import { render } from "./1Sekretariat.vue?vue&type=template&id=dfe3397c&scoped=true"
import script from "./1Sekretariat.vue?vue&type=script&lang=js"
export * from "./1Sekretariat.vue?vue&type=script&lang=js"

import "./1Sekretariat.vue?vue&type=style&index=0&id=dfe3397c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe3397c"]])

export default __exports__